import { SprintStatus } from '../../../../../lib/functions/sprint'
import { UserBasic } from '../../../../../lib/functions/user'

/**
 * スプリントラベルをフォーマットする
 * 日付がある場合: "スプリント名（MM/DD～MM/DD）"
 * 日付がない場合: "スプリント名"
 */
export const formatSprintLabel = (
  sprintName: string,
  startDate: string,
  endDate: string,
  formatDate: (dateStr: string) => string
): string => {
  if (!startDate) return sprintName
  return `${sprintName}（${formatDate(startDate)}～${formatDate(endDate)}）`
}

/** デフォルトで展開するステータス */
export const EXPANDED_STATUSES: SprintStatus[] = [
  SprintStatus.INPROGRESS,
  SprintStatus.STANDBY,
]

/** デフォルトで折りたたむステータス */
export const COLLAPSED_STATUSES: SprintStatus[] = [
  SprintStatus.FINISHED,
  SprintStatus.CANCELED,
]

/**
 * ステータスごとにアイテムをグルーピングする
 * status が未設定のアイテムは unsetItems に振り分ける
 */
export const groupByStatus = <T extends { status?: SprintStatus }>(
  items: T[]
): { groups: Map<SprintStatus, T[]>; unsetItems: T[] } => {
  const groups = new Map<SprintStatus, T[]>()
  const unsetItems: T[] = []
  for (const item of items) {
    if (!item.status) {
      unsetItems.push(item)
      continue
    }
    const group = groups.get(item.status)
    if (group) {
      group.push(item)
    } else {
      groups.set(item.status, [item])
    }
  }
  return { groups, unsetItems }
}

export type ViewMode = 'workload' | 'selection'

/** スプリント選択モード用（スプリント単位） */
export interface SprintSelectionItem {
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  checked: boolean
  status?: SprintStatus
}

/** 工数入力モード用（SPI単位） */
export interface SpiAdjustmentItem {
  /** SPI UUID（新規の場合は仮UUID） */
  uuid: string
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  estimatedHour: number
  assignee: UserBasic | null
  /** 新規追加かどうか */
  isNew: boolean
}
